import React from 'react';

const SmsNotification = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.5 13.125V19.375C27.5 23.75 25 25.625 21.25 25.625H8.75C5 25.625 2.5 23.75 2.5 19.375V10.625C2.5 6.25 5 4.375 8.75 4.375H17.5"
        stroke="#DC00FE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 11.25L12.6625 14.375C13.95 15.4 16.0625 15.4 17.35 14.375L18.825 13.2"
        stroke="#DC00FE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.375 10C26.1009 10 27.5 8.60089 27.5 6.875C27.5 5.14911 26.1009 3.75 24.375 3.75C22.6491 3.75 21.25 5.14911 21.25 6.875C21.25 8.60089 22.6491 10 24.375 10Z"
        stroke="#DC00FE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SmsNotification;
